module.exports = __webpack_public_path__ + "static/media/app_logo.479108d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_logo.svg
// module id = 409
// module chunks = 12